<script lang="ts" module>
  import {
    Popper,
    type PopperContentProps,
  } from "#lib/components/ui/popper/index"
  import { dismissable } from "#lib/internal/actions"
  import { getTooltipRootContext } from "../TooltipRoot.svelte"
  import { TOOLTIP_OPEN } from "../constants"

  export type TooltipContentImplProps = PopperContentProps
</script>

<script lang="ts">
  import { onDestroy, onMount, type Snippet } from "svelte"

  type Props = TooltipContentImplProps & { children?: Snippet }

  let {
    use = [],
    ref = $bindable(null),
    children,
    ...restProps
  }: Props = $props()

  const rootCtx = getTooltipRootContext()

  onMount(() => {
    document.addEventListener(TOOLTIP_OPEN, rootCtx.onClose)
    return () => {
      document.removeEventListener(TOOLTIP_OPEN, rootCtx.onClose)
    }
  })

  const handleScroll = (event: Event) => {
    const target = event.target as HTMLElement
    if (target?.contains(rootCtx.trigger)) {
      rootCtx.onClose()
    }
  }

  $effect(() => {
    window.removeEventListener("scroll", handleScroll, { capture: true })
    if (rootCtx.trigger) {
      window.addEventListener("scroll", handleScroll, { capture: true })
    }
  })

  onDestroy(() => {
    window.removeEventListener("scroll", handleScroll, { capture: true })
  })
</script>

<Popper.Content
  {...restProps}
  use={[
    ...(use ?? []),
    [
      dismissable,
      {
        onDismiss: () => {
          rootCtx.onClose()
        },
      },
    ],
  ]}
  data-state={rootCtx.stateAttribute}
  bind:ref
>
  {@render children?.()}
</Popper.Content>
